import { GET_DATASET_INFO, GET_DATASET_INFO_EVO } from '../actions/HomeActions';

const initialState = {
	DatasetInfo: [],
	DatasetInfoEVO: []
};

const homeReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_DATASET_INFO: {
						return {
							...state,
							DatasetInfo: action.DatasetInfo
						};
					}
					case GET_DATASET_INFO_EVO: {
						return {
							...state,
							DatasetInfoEVO: action.DatasetInfoEVO
						};
					}
					default: {
						return state;
					}
	}
};

export default homeReducer;
